export var GcsLocationType;
(function (GcsLocationType) {
    GcsLocationType["GCS_LOCATION_TYPE_UNSPECIFIED"] = "GCS_LOCATION_TYPE_UNSPECIFIED";
    GcsLocationType["GCS_LOCATION_TYPE_REGION"] = "region";
    GcsLocationType["GCS_LOCATION_TYPE_DUAL_REGION"] = "dual-region";
    GcsLocationType["GCS_LOCATION_TYPE_MULTI_REGION"] = "multi-region";
    GcsLocationType["GCS_LOCATION_TYPE_ZONE"] = "zone";
})(GcsLocationType || (GcsLocationType = {}));
